var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsesContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 41,
    viewBox: "0 0 24 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 17.5C5.7835 17.5 5 18.2835 5 19.25V19.75C5 20.7165 5.7835 21.5 6.75 21.5C7.7165 21.5 8.5 20.7165 8.5 19.75V19.25C8.5 18.2835 7.7165 17.5 6.75 17.5ZM12 17.5C11.0335 17.5 10.25 18.2835 10.25 19.25V19.75C10.25 20.7165 11.0335 21.5 12 21.5C12.9665 21.5 13.75 20.7165 13.75 19.75V19.25C13.75 18.2835 12.9665 17.5 12 17.5ZM17.25 17.5C16.2835 17.5 15.5 18.2835 15.5 19.25V19.75C15.5 20.7165 16.2835 21.5 17.25 21.5C18.2165 21.5 19 20.7165 19 19.75V19.25C19 18.2835 18.2165 17.5 17.25 17.5Z",
    fill: "#7D94AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsesContainer);
export default __webpack_public_path__ + "static/media/ellipses-container.5b9ce187722b7c7321a61de7b1ee43de.svg";
export { ForwardRef as ReactComponent };